import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import ArrowDoen from './assets/arrow-down.svg'
import { languageIconMap } from './constant'
import { useMemo } from 'react'
import { useSelectLang } from '@/hooks/lang/useSelectLang'
import { cn } from '@/styles'
import { Language } from '@/hooks/lang/constant'

// 多語系下拉選單
const LanguageDropdown = () => {
  const { languageLabelMap, localesOptions, locale, setLocale } = useSelectLang()

  const languageOptions = useMemo(() => {
    return localesOptions
      .filter((option) => option.label)
      .map(({ value, label }) => ({
        value,
        label,
        icon: languageIconMap.get(value as Language),
      }))
  }, [localesOptions])

  return (
    <div className="absolute top-12 right-12 z-1 sm:fixed sm:top-40 sm:right-40">
      <DropdownMenu>
        {/* 按鈕 */}
        <DropdownMenuTrigger className="sm:rounded-10 text-16 flex size-32 cursor-pointer items-center justify-center rounded-full bg-white sm:h-48 sm:w-147 sm:space-x-10 sm:bg-[#1c3fa7]">
          <span className="hidden text-white sm:block">{languageLabelMap.get(locale as Language)}</span>
          <img src={languageIconMap.get(locale as Language)} className="size-24 shrink-0 sm:h-22 sm:w-23" />
          <ArrowDoen className="hidden h-5 w-7 sm:block" />
        </DropdownMenuTrigger>

        {/* 內容 */}
        <DropdownMenuContent className="ms:py-8 w-104 px-0 py-4 sm:w-147" side="bottom" align="end" sideOffset={6}>
          {languageOptions.map((option) => (
            <DropdownMenuItem
              key={option.value}
              className={cn('flex h-32 cursor-pointer flex-row-reverse items-center justify-end gap-8 px-8 text-[#0D2245] sm:h-36 sm:flex-row sm:justify-between sm:pr-14 sm:pl-20 sm:text-white', {
                'text-[#6D7693] hover:bg-[#6D7693]/40 hover:text-white': locale !== option.value,
              })}
              onClick={() => setLocale(option.value)}>
              <span className="text-14 sm:text-16">{languageLabelMap.get(option.value as Language)}</span>
              <img src={languageIconMap.get(option.value as Language)} className="size-24 shrink-0 sm:h-22 sm:w-23" />
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}

export default LanguageDropdown
